import { useCallback } from "react";

import { MONOLITH_ORIGIN } from "@/monolithIntegration/monolithIntegration.constants";
import useRestMutation from "@/remoteState/useRestMutation";

const useTeacherUpdate = () => {
  const setTeacher = useCallback((payload) => {
    return new Request(`${MONOLITH_ORIGIN}/api/v2/teacher/${payload.id}/`, {
      method: "POST",
      body: JSON.stringify(payload),
      headers: { "Content-Type": "application/json" },
    });
  }, []);

  return useRestMutation(setTeacher);
};

export default useTeacherUpdate;
